<script setup>
import { computed } from "vue";

const props = defineProps({
  currentPage: { type: Number, required: true },
  totalPages: { type: Number, required: true },
});

const emit = defineEmits(["change-page"]);

function goToPage(page) {
  if (page < 1 || page > props.totalPages || page === '...') {
    return;
  }
  emit("change-page", page);
}

function previousPage() {
  goToPage(props.currentPage - 1);
}

function nextPage() {
  goToPage(props.currentPage + 1);
}

const pages = computed(() => {
  const pageRange = [];
  const total = props.totalPages;
  const current = props.currentPage;
  const range = 2;

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pageRange.push(i);
  } else {
    pageRange.push(1);
    if (current > range + 2) pageRange.push('...');
    for (let i = Math.max(2, current - range); i <= Math.min(total - 1, current + range); i++) {
      pageRange.push(i);
    }
    if (current < total - (range + 1)) pageRange.push('...');
    pageRange.push(total);
  }
  return pageRange;
});
</script>

<template>
  <div class="paginator" v-if="totalPages > 0">
    <button @click="previousPage" :disabled="currentPage === 1" class="page-btn">
      <i class="fas fa-chevron-left"></i>
    </button>
    <template v-for="(page, index) in pages" :key="index">
      <span v-if="page === '...'" class="page-btn-ellipsis">...</span>
      <button
        v-else
        @click="goToPage(page)"
        :class="{ 'page-btn': true, active: page === currentPage }"
      >
        {{ page }}
      </button>
    </template>
    <button @click="nextPage" :disabled="currentPage === totalPages" class="page-btn">
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>
</template>

<style scoped>
/* Estilos são idênticos aos do PaginationButtons.vue original */
.paginator { display: flex; gap: 4px; }

.page-btn {
  min-width: 32px;
}

.page-btn-ellipsis {
  display: flex; align-items: center; justify-content: center;
  padding: 0 8px; height: 32px; color: #6c757d;
}
</style>